import { ModalActionButton, ModalActions, ModalContent, useModalTitle, withModal, } from '@topconagriculture/modal';
import { withBaseProps } from '@topconagriculture/react-components';
import * as React from 'react';
import { compose, withHandlers } from 'recompose';
import { ProfilingForms } from '../../config';
import { UserForm } from '../UserForm';
const UserModal = (props) => {
    const { onSubmitHandler, onProfileUpdate, user, userApps, isLoadingUserData, isEditingProfile, disabled, t, closeModal, } = props;
    const translationKey = user ? 'modal_title_edit' : 'modal_title_create';
    useModalTitle(t(`profiling:user_settings:${translationKey}`));
    return (React.createElement("div", null,
        React.createElement(ModalContent, null,
            React.createElement(UserForm, { onProfileUpdate: onProfileUpdate, user: user, userApps: userApps, isLoading: isLoadingUserData })),
        React.createElement(ModalActions, { closeModal: closeModal },
            React.createElement(ModalActionButton, { testId: "save-user", disabled: disabled, isLoading: isEditingProfile, action: onSubmitHandler, btnLabel: t('common:save') }))));
};
export default compose(withModal, withBaseProps({ translations: ['profiling', 'common'] }), withHandlers({
    onSubmitHandler: ({ submit }) => () => {
        submit(ProfilingForms.editUserProfile);
    },
    onProfileUpdate: ({ updateProfile }) => (user) => {
        updateProfile(user);
    },
}))(UserModal);
//# sourceMappingURL=UserModal.js.map